import { render, staticRenderFns } from "./index_msg.vue?vue&type=template&id=02595b26&scoped=true&"
import script from "./index_msg.vue?vue&type=script&lang=js&"
export * from "./index_msg.vue?vue&type=script&lang=js&"
import style0 from "./index_msg.vue?vue&type=style&index=0&id=02595b26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02595b26",
  null
  
)

export default component.exports